<template>

  <div class="fullwidth about narex">
    <editable-item :page="$route.name" item="text" :loaded="editableLoaded" />
    <div v-show="$store.state.user">
      <div class="padform">
        <input type="password" placeholder="new password" v-model="password" />
      </div>
      <div class="button-panel">
        <small-button v-on:click="handleChangePassword" large>{{ $nippets.changePassword }}</small-button>
      </div>
    </div>
    <div v-show="!$store.state.user">
      <p>{{ $nippets.notAvailable }}</p>
    </div>
  </div>

</template>

<script>
import ah from '@/auth-handler.js'
import EditablePage from '@/mixins/EditablePage.js'
import '@/css/my-area.css'

export default {
  mixins: [EditablePage],
  data: function () {
    return {
      password: '',
      oldPassword: ''
    }
  },
  methods: {
    handleChangePassword: async function () {
      try {
        await ah.handleCompletePassword(this.password)
      }
      catch(err){
        this.$k.messageBox(this.$nippets.changePassword, err.message)
        return
      }
      this.$k.messageBox(this.$nippets.changePassword, this.$nippets.changePasswordSuccess)
      this.$ixr.push('/')
    }
  }
}
</script>

